import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";
import { BsFiletypeSvg } from "react-icons/bs";
import { LuTrash } from "react-icons/lu";
import Retry from "../../svg/retry";
import EditIcon from "../../svg/editIcon";
import { Switch, Button } from "@mantine/core";
import {
  useGetLocationsQuery,
  useLazyGetS3UrlQuery,
  useGetFloorsQuery,
} from "../../redux/slices/api.slice";
import { useGetFloorQuery } from "../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import api from "../../redux/slices/api.slice";
import { IoCloudUploadOutline } from "react-icons/io5";
import { Select } from "@mantine/core";
import { Formik, ErrorMessage } from "formik";
import { useAddFloorsMutation } from "../../redux/slices/api.slice";
import { useParams } from "react-router-dom";
import { resetGetFloorStatus } from "../../redux/slices/groups.slice";
import { notifications } from "@mantine/notifications";
import { MultiSelect } from "@mantine/core";

import * as Yup from "yup";
import Container from "../../components/Container";

const NewFloor = () => {
  const [fetchS3URL] = useLazyGetS3UrlQuery();
  const [addFloorMutation, { isLoading: isLoadingAddedFloor }] =
    useAddFloorsMutation();
  const { id: locationID } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [floorID, setFloorID] = useState("");
  const { data: groups } = useGetLocationsQuery("");
  const { isLoading } = useGetFloorQuery(floorID, { skip: !floorID });

  useEffect(() => {
    const currentLocGrp = groups?.find((l: any) => l.id === locationID);
    const crumbs = [
      { name: "Home", route: "/" },
      {
        name: currentLocGrp?.name,
        route: `/Location/${locationID}`,
      },
      { name: "New Floor", route: "" },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, [groups, locationID]);

  const initalFloorValues = {
    locationID,
    Name: "",
    live: false,
    svgURL: "",
    position: 0,
    amenities: [],
  };

  const addFloorValidationSchema = Yup.object().shape({
    Name: Yup.string().required("Required"),
    position: Yup.number().min(0, "The number must be positive"),
    svgURL: Yup.string().test(
      "is-svg",
      "Unsupported format, only SVGs allowed",
      (value) => !value || value.endsWith(".svg")
    ),
  });
  const [loadingFloorSvg, setLoadingFloorSvg] = useState<boolean>(false);
  const [errorFloorSvg, setErrorFloorSvg] = useState<boolean>(false);
  const imgRef = useRef(null);

  const handleUploadImages = async (e, setFieldValue, valueName) => {
    const file = e.target.files;
    const cloud = process.env.REACT_APP_CLOUDFRONT_URL;
    const timestamp = Math.floor(new Date().getTime() / 1000);
    const fileName = file[0].name.split(".")[0];
    const ext = file[0].name.split(".")[1];
    const sizeInBytes = file[0]?.size
      ? Number((file[0].size / 1024).toFixed(1))
      : 0;
    imgRef.current = { name: file[0].name, size: sizeInBytes };

    try {
      setLoadingFloorSvg(true);
      setErrorFloorSvg(false);
      const { data: URL } = await fetchS3URL({
        fileName: `${fileName}-${timestamp}.${ext}`,
      });

      const res = await fetch(URL, {
        method: "PUT",
        body: file[0],
      });
      if (res.ok) {
        setFieldValue(valueName, `${cloud}${fileName}-${timestamp}.${ext}`);

        setLoadingFloorSvg(false);
      } else {
        setFieldValue(valueName, "");
        setErrorFloorSvg(true);
      }
    } catch (e) {
      console.log("err", e);
      setLoadingFloorSvg(false);
      setErrorFloorSvg(true);
    }
  };
  const amenitiesData = [
    "Wi-Fi Available",
    "Coffee Space",
    "Meetings Room",
    "Printers",
    "Wheelchair Accessible",
    "Pet-friendly",
    "Lounge Area",
    "Quiet Zones",
  ];
  const handleAddFloorSubmit = async (values, helpers) => {
    try {
      const result = await addFloorMutation({
        id: locationID,
        floorData: values,
      });

      //@ts-ignore
      if (result.data) {
        //@ts-ignore
        setFloorID(result.data.id);
        dispatch(api.util.invalidateTags(["Locations"]));

        notifications.show({
          title: "Success",
          message: "Floor added successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
    helpers.resetForm();
    imgRef.current = null;
    navigate(`/Location/${locationID}`);
  };
  const handleDeleteSVG = (setFieldValue) => {
    setFieldValue("svgURL", "");
    imgRef.current = null;
    setLoadingFloorSvg(false);
    setErrorFloorSvg(false);
  };
  console.log("imgRef", imgRef);
  return (
    <Container>
      <div className="relative ">
        <Formik
          initialValues={initalFloorValues}
          onSubmit={(values, helpers) => {
            handleAddFloorSubmit(values, helpers);
          }}
          validationSchema={addFloorValidationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="sticky py-4 z-40 bg-white top-0 w-full flex justify-between  gap-4 sm:gap-0 items-start sm:items-center sm:flex-row flex-col">
                <h2 className="text-3xl md:text-4xl xl:text-5xl  font-md">
                  Create New Floor
                </h2>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  color={"#FB6514"}
                  radius="xl"
                  size="md"
                  loading={isLoadingAddedFloor}
                >
                  {values.live ? "Save & Set Live" : "Save New Floor"}
                </Button>
              </div>
              <div className="grid pb-[50px] grid-cols-1 md:grid-cols-2  2xl:gap-14  gap-10 2xl:w-[85%] w-full mx-auto xl:mt-20 mt-10">
                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Floor Name
                  </h2>
                  <p className="text-grayText2 text-base">
                    This will be displayed as the floor plan.
                  </p>
                </div>
                <div className="flex flex-col gap-2 ">
                  <input
                    type="text"
                    name="Name"
                    value={values.Name}
                    className={`${
                      errors.Name && touched.Name
                        ? "border-alert "
                        : "border-lightGray2"
                    } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
                    placeholder="Floor Name"
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="Name"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Floor Position
                  </h2>
                  <p className="text-grayText2 text-base">
                    This is the position of the floor in the building. It will
                    be used to order the floors in the building.
                  </p>
                </div>
                <div className="flex flex-col gap-2 ">
                  <input
                    type="number"
                    name="position"
                    value={values.position}
                    className={`${
                      errors.position && touched.position
                        ? "border-alert "
                        : "border-lightGray2"
                    } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
                    placeholder="Floor position"
                    onChange={handleChange}
                    min={0}
                  />
                  <ErrorMessage
                    name="position"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Amenities
                  </h2>
                  <p className="text-grayText2 text-base">
                    Select all amenities that a floor can have
                  </p>
                </div>
                <MultiSelect
                  data={amenitiesData}
                  value={values.amenities}
                  onChange={(val) => setFieldValue("amenities", val)}
                  withScrollArea={false}
                  clearable
                  styles={{
                    dropdown: {
                      maxHeight: 180,
                      overflowY: "auto",
                      borderColor: "#BBC3CF",
                    },
                    input: { borderRadius: "8px", borderColor: "#BBC3CF" },
                  }}
                />
                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Floor SVG
                  </h2>
                  <p className="text-grayText2 text-base">
                    This will be displayed as the floor plan.
                  </p>
                </div>

                <div className="flex flex-col gap-2 ">
                  <div
                    className={` min-h-28  relative w-full flex-col flex  items-center  border border-solid   justify-center  rounded-md  py-4 px-2 ${
                      (errors.svgURL && touched.svgURL) || errorFloorSvg
                        ? "border-alert"
                        : "border-lightGray2"
                    }   `}
                  >
                    {!imgRef.current && !errorFloorSvg && (
                      <input
                        type="file"
                        name="svgURL"
                        accept="image/*"
                        onChange={(e) =>
                          handleUploadImages(e, setFieldValue, "svgURL")
                        }
                        className="absolute  inset-0 opacity-0 sm:text-base text-sm  "
                      />
                    )}

                    {loadingFloorSvg && !errorFloorSvg ? (
                      <p className="text-grayText3">
                        uploading image<span className="loading">...</span>
                      </p>
                    ) : errorFloorSvg ? (
                      <ErrorUploadingSvg
                        file={imgRef.current}
                        handleDelete={handleDeleteSVG}
                        handleEdit={handleUploadImages}
                        setFieldValue={setFieldValue}
                      />
                    ) : imgRef.current ? (
                      <SvgContent
                        file={imgRef.current}
                        handleDelete={handleDeleteSVG}
                        handleEdit={handleUploadImages}
                        setFieldValue={setFieldValue}
                      />
                    ) : (
                      <UploadSVG />
                    )}
                  </div>

                  <ErrorMessage
                    name="svgURL"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Floor Status
                  </h2>
                  <p className="text-grayText2 text-base">
                    Set the Floor to 'Live' and save to make it visible to
                    users. This step confirms it's ready for use and ensures
                    accurate display.
                  </p>
                </div>

                <div>
                  <Switch
                    size="md"
                    // value={values.live}
                    label={values.live ? "Live" : "Draft"}
                    name="live"
                    onChange={handleChange}
                    checked={values.live}
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

export default NewFloor;

const SvgContent = ({ handleDelete, file, handleEdit, setFieldValue }) => {
  const editRef = useRef(null);
  return (
    <div
      data-cy="svgURL" // TODO : update this when testing
      className="flex  items-center h-full w-full justify-between px-2"
    >
      <div className="flex items-center gap-4">
        <BsFiletypeSvg className="text-4xl" />

        <div>
          <p className="text-[17px]">{file.name}</p>
          {file.size > 0 && (
            <p className="text-grayText3 text-sm">{`${file.size}KB`}</p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-4">
        <input
          type="file"
          name="svgURL"
          ref={editRef}
          accept="image/svg"
          onChange={(e) =>
            e.target.files && handleEdit(e, setFieldValue, "svgURL")
          }
          className="hidden "
        />
        <div
          onClick={() => {
            editRef.current.click();
          }}
          className="cursor-pointer flex justify-center"
        >
          <EditIcon />
        </div>

        <LuTrash
          className="text-xl cursor-pointer text-grayText3"
          onClick={(e) => {
            handleDelete(setFieldValue);
          }}
        />
      </div>
    </div>
  );
};

const UploadSVG = () => {
  return (
    <>
      <div
        style={{ border: "6px solid #F7F8F9" }}
        className="flex justify-center items-center rounded-[50%] w-12 h-12 bg-lightGray my-2"
      >
        <IoCloudUploadOutline className="text-grayText text-xl" />
      </div>

      <p className="text-action pr-1 text-base font-medium  ">
        Click to upload
      </p>

      <p className="text-grayText2 text-sm">{`SVG (max. 800x400px)`}</p>
    </>
  );
};

const ErrorUploadingSvg = ({
  handleDelete,
  file,
  handleEdit,
  setFieldValue,
}) => {
  const editRef = useRef(null);

  return (
    <div className="flex  items-center h-full w-full justify-between px-2">
      <div className="flex items-center gap-4">
        <BsFiletypeSvg className="text-4xl text-alert" />

        <div>
          <p className="text-[17px] text-alert">{file.name}</p>
          {file.size > 0 && (
            <p className="text-alert text-sm">{`${file.size}KB`}</p>
          )}
        </div>
      </div>
      <div className="flex gap-8 items-center">
        <p className="text-base italic text-grayText3">Upload Failed</p>

        <div className="flex items-center gap-4">
          <input
            type="file"
            name="svgURL"
            ref={editRef}
            accept="image/svg"
            onChange={(e) =>
              e.target.files && handleEdit(e, setFieldValue, "svgURL")
            }
            className="hidden "
          />
          <div
            onClick={() => {
              editRef.current.click();
            }}
            className="cursor-pointer flex justify-center"
          >
            <Retry fill={"#4D5F7A"} width={18} height={18} />
          </div>

          <LuTrash
            className="text-xl cursor-pointer text-grayText3"
            onClick={(e) => {
              handleDelete(setFieldValue);
            }}
          />
        </div>
      </div>
    </div>
  );
};
